import { useEffect, useState } from "react";

// What the renderer draws from when appback has no manifest to give: no art,
// rather than the renderer's own default URL, a pack tapp does not serve.
export const NO_ART = Object.freeze({ assets: Object.freeze({}) });

/**
 * The art manifest the live renderer draws a board or scene from (TT-1310),
 * for BoardCanvas's `artManifest` and useSceneComposition's `manifest`: the
 * catalog's, through the resource adapter (a signed-in host's, or a live
 * link's). Null while it is read, which holds the canvas back; NO_ART if
 * appback has none, so the board or scene still draws, without art.
 * `renderer` is "board" or "scene".
 */
export default function useArtManifest(resources, renderer) {
  const [manifest, setManifest] = useState(null);
  useEffect(() => {
    let cancelled = false;
    setManifest(null);
    resources.loadArtManifest(renderer).then((m) => !cancelled && setManifest(m || NO_ART));
    return () => {
      cancelled = true;
    };
  }, [resources, renderer]);
  return manifest;
}
